import { u as m } from "./useThemeWithoutDefault-9240f28c.js";
import { a as t } from "./createTheme-ef7fa3a1.js";
const r = t();
function u(e = r) {
  return m(e);
}
export {
  u
};
//# sourceMappingURL=useTheme-89580aa5.js.map
